import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user-dark",
  "use": "user-dark-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"user-dark\"><g transform=\"translate(8.281 6.5)\" stroke=\"#333\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"7.718\" cy=\"6.5\" r=\"5.5\" /><path d=\"M0 18c.727-1.755 2.758-2.814 4.698-3 1.17-.112 1.666-.156 3.02-.156 1.355 0 1.967.044 3.02.156 1.9.202 3.971 1.245 4.698 3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol